// extracted by mini-css-extract-plugin
export default {"dashboard":"DashboardPage_dashboard__1gSYs","welcome":"DashboardPage_welcome__gIJ8u","cards":"DashboardPage_cards__My2oF","card":"DashboardPage_card__JwpfI"};